module.exports = __webpack_public_path__ + "img/sentiment_very_dissatisfied.11fc3cd9.svg";